import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { PopupChiTiet } from "./PopupChiTiet";

export const BtnThongTinVay = ({ item, IdCuaHang }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="chi tiết"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <i className="mdi mdi-clipboard-text-outline"></i>
        </PopoversBootrap>
      </a>
      {show && (
        <PopupChiTiet
          show={show}
          onHide={handleClose}
          data={item}
          IdCuaHang = {IdCuaHang}
        />
      )}
    </>
  );
};
